import React from 'react';

const PaymentCancel = () => {
  return (
    <div className='h-[100vh] flex flex-col items-center mt-10'>
        <h2>Cancel</h2>
        <h5>Your payment was canceled.</h5>
    </div>
  );
}

export default PaymentCancel;
